<template>
	<div class="notif"
		:style="{ transform: 'translateY(' + offset + 'px)' }" 
		:class="[ active ? 'notif--active' : '', 'notif--' + size, !!message ? 'notif--text' : '' ]"
		@mouseenter="!mobile && !anchor ? hover = true : ''"
		@mouseleave="hover = false"
		>
		<img @click="toggleNotif()" class="notif__bell" :src="require('../assets/' + icon)" />
		<div v-if="!!message" class="notif__message">
			{{message}}
		</div>
		<div v-if="!!anchor" @click="toggleNotif()" class="notif__anchor">
			{{anchor}}
		</div>
		<!--  -->
		<tooltip
			v-if="!mobile && !message && (hover || inTransition)"
			:content="currentTooltipTxt"
			:placement="'fixed'"
			:fixed="{ top: '125%', left: element == 'institution' ? '-50%' : '-80%' }"
			:scan="(!active || inTransition) && !error ? 'info' : 'alert'"
			:font-size="1.2"
			:min-width="tooltipWidth"
			:style="{ transform: 'translateZ(1px)', zIndex: 'unset' }"
		/>
	</div> 
</template>
<script>
	import Tooltip from 'global/components/Tooltip'
	export default {
		name: 'Notif',
		components: { Tooltip },
		props: {
			story: {
				type: String,
				required: true
			},
			element: {
				type: String,
				required: true
			},
			value: {
				type: String,
				required: true
			},
			offset: {
				type: Number,
				default: 0,
			},
			size: {
				type: String,
				default: 'regular' // can be 'small' or 'regular'
			},
			tooltipTxt: {
				type: Object,
				default: () => {
					return {
						enable: 'Texte pour activer la notif',
						disable: 'Texte pour déactiver la notif',
						enabled: 'Texte quand la notification a été activée',
						disabled: 'Texte quand la notification a été désactivée',
						error: 'Texte en cas d’erreur',
					}
				}
			},
			anchors: {
				type: Object,
				default: null,
			},
			messages: {
				type: Object,
				default: null,
			},
		},
		data: function() {
			return {
				active: false,
				hover: false,
				inTransition: '',
				config: this.$root.$children[0].notificationsConfig,
				debug: this.$root.$children[0].debug,
				error: false,
			}
		},
		computed: {
			tooltipWidth: function() {
				if (this.currentTooltipTxt.length < 20) return 100
				return 150
			},
			id: function() {
				return this.story + '||' + this.element + '||' + this.value
			},
			anchor: function() {
				if (!this.anchors) return ''
				if (this.error) return this.anchors.error
				if (this.inTransition == 'after-url') return this.anchors.ack
				if (this.active) return this.anchors.disable
				return this.anchors.enable
			},
			message: function() {
				if (!this.messages) return ''
				if (this.error) return this.messages.error
				if (this.inTransition == 'after-url') return this.messages.ack
				if (this.active) return this.messages.disable
				return this.messages.enable
			},
			icon: function() {
				let name = 'bell'
				name += this.size == 'small' || !!this.anchor ? '-small' : ''
				name += this.active ? '-active' : '-inactive'
				name += this.hover ? '-hover' : ''
				return name + '.svg'
			},
			currentTooltipTxt: function() {
				if (this.error) return this.tooltipTxt.error
				if (this.active && this.inTransition) return this.tooltipTxt.enabled
				if (!this.active && this.inTransition) return this.tooltipTxt.disabled
				if (this.active) return this.tooltipTxt.disable
				return this.tooltipTxt.enable
			},
		},
		created() {
			let thisNotif = this.$root.$children[0].activeNotifications.find(n => n == this.id)
			if (!!thisNotif) this.active = true
		},
		methods: {
			updateNotif: function(onOff, trigger) {
				let delay = trigger == 'url' ? 5000 : 2000
				this.active = onOff == 'on' ? true : false
				this.inTransition = 'after-' + trigger
				if (onOff == 'on') this.$root.$children[0].activeNotifications.push(this.id)
				if (onOff == 'off') this.$root.$children[0].activeNotifications = this.$root.$children[0].activeNotifications.filter(n => n != this.id)
				/*
				if (this.debug) {
					console.log('activeNotifications:')
					this.$root.$children[0].activeNotifications.forEach(id => {
						console.log(id)
					})
				}
				*/
				setTimeout(() => {
					this.inTransition = ''
				}, delay)

			},
			showError: function(err) {
				this.error = true
				if (this.debug) {
					console.log('Could not get change notification status:')	
					console.log(err)
				}
				setTimeout(() => {
					this.error = false
				}, 3000)
			},
			toggleNotif: function(onOff, trigger='click') {

				// Sending request to store notification change
				if (!onOff) onOff = this.active ? 'off' : 'on'
				if (this.debug) {
					console.log('')
					console.log('')
					console.log('###')
					console.log('onOff:', onOff)
					console.log('id:', this.id)
				}
				let token = this.$root.$children[0].csrfToken
				let url = 'https://' + parent.location.hostname 
				if (this.isDev) url = 'https://preprod.contexte.io'
				url += this.config.api.set 
				let body = {
					app_label: 'institutions',
					model_name: this.element,
					code: this.value,
					following: onOff == 'on' ? true : false
				}
				if (this.debug) {
					console.log('Sending POST request to API at this URL:')
					console.log(url)
					console.log('Body:')
					console.log(body)
				}
				if (!this.isDev) fetch(url, {
					method: 'POST',
					body: JSON.stringify(body),
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'X-CSRFToken': token
					},
				})
				.then(response => {
					if (response.status == 200) {

						// Request was successful!
						if (this.debug) console.log('Request was successful!')
						this.updateNotif(onOff, trigger)
					} else {

						// Request was unsuccessful…
						this.showError(response.status)
					}
				})
				.catch(error => {

					// No anwser from notification API
					this.showError(error)
				})	
				if (this.isDev) {
					// this.error = true
					this.updateNotif(onOff, trigger)
					/*
					console.log('####')
					console.log(onOff == 'on' ? 'Notification activated!' : 'Notification deactivated!')
					console.log('story:', this.story)
					console.log('element:', this.element)
					console.log('value:', this.value)
					console.log('POST request url:')
					console.log(url)
					console.log('POST request body:')
					console.log(body)
					console.log('')
					*/
				}
			}
		}, 
	}
</script>
<style lang="scss">
	@import 'global/css/contexte.apps.colors.2.0';
	.notif {
		margin-left: .15em;
		cursor: pointer;
		display: inline-block;
		width: 28px;
		vertical-align: -8px;
		position: relative;
		z-index: 2; 
		&--text {
			vertical-align: unset;
			padding: 1rem;
			font-size: 1.5rem;
			width: unset;
			display: block;
			cursor: default;
			background-color: $box-scan-fill;
			border: 1px solid $box-scan-border; 
			display: flex;
			flex-wrap: wrap;
			border-radius: 4px;
			align-items: center;
			gap: 0 1em;
			&.notif--active {
				background-color: $box-scan-fill-blue;
				border-color: $box-scan-border-blue;
				.notif__anchor {
					color: $red-scan;
				}
			}
			.notif__bell {
				flex: 0 0 28px;
			}
			.notif__message {
				flex: 1 1 300px;
			}
			.notif__anchor {
				flex: 0 0 auto;
				font-weight: 400;
				font-size: 1.3rem;
				margin-left: auto;
				color: $blue-scan;
				text-decoration: underline;
				cursor: pointer;
				&:hover {
					text-decoration: none;
				}
			}
		} 
		&--small {
			width: 21px;
		}
		&__bell {
			width: 100%;
		}
	}

	// Add-on for mobile screens
	@media screen and (max-width: 600px)  {
		.notif {
			&--text {
				position: relative;
				padding-left: 40px;
				.notif__bell {
					position: absolute;
					width: 30px;
					height: 30px;
					top: 13px;
					left: 5px;
				}
				.notif__anchor {
					margin-top: 8px;
				}
			}
		}
	}
</style>